import { ArrowRight } from "lucide-react";

const Button = ({ text, styles = "", Icon = ArrowRight, ...rest }) => {
  return (
    <button
      className={`button bg-purple-06 rounded-full py-3 px-10 flex gap-1 items-center justify-center text-white button hover:bg-purple-04 w-full active:bg-purple-07 disabled:bg-grey-02 disabled:text-grey-01 ${styles}`}
      {...rest}
    >
      {text} {Icon && <Icon className="shrink-0"/>}
    </button>
  );
};

export default Button;
